import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { loadConfig } from "./config/config";
import { ConfigProvider } from "./config/ConfigProvider";
import { ApiProvider } from "./api/ApiProvider";
import { buildOidcConfig } from "./auth/oidcConfig";
import { ErrorBanner } from "./components/ErrorBanner";
import { App } from "./App";
import "./styles.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}
const root = createRoot(rootElement);

// Load runtime config BEFORE rendering so the OIDC provider gets real values.
loadConfig()
  .then((config) => {
    const oidcConfig = buildOidcConfig(config.cognito);
    root.render(
      <StrictMode>
        <ConfigProvider value={config}>
          <AuthProvider {...oidcConfig}>
            <BrowserRouter>
              <ApiProvider>
                <App />
              </ApiProvider>
            </BrowserRouter>
          </AuthProvider>
        </ConfigProvider>
      </StrictMode>,
    );
  })
  .catch((err: unknown) => {
    const message = err instanceof Error ? err.message : String(err);
    root.render(
      <div className="centered-screen">
        <div className="auth-error-card">
          <ErrorBanner
            title="Configuration error"
            message={`The app could not start: ${message}`}
            onRetry={() => window.location.reload()}
            retryLabel="Reload"
          />
        </div>
      </div>,
    );
  });
